import { useEffect, useState } from 'react';
import { postMessageToRN } from '../../utils/RNCommunicator/postMessageToRN.util';
import { setRNMessageReceiver } from '../../utils/RNCommunicator/setRNMessageReceiver.util';

interface useGetCurrentPositionReturn {
  latitude: undefined | string;
  longitude: undefined | string;
  isGetPositionPermissionAllowed: undefined | boolean;
}

export const useGetCurrentPosition = (): useGetCurrentPositionReturn => {
  const [latitude, setLatitude] = useState<string>();
  const [longitude, setLongitude] = useState<string>();
  const [isGetPositionPermissionAllowed, setIsGetPositionPermissionAllowed] = useState<boolean>();

  const successHandler = (event: any) => {
    setIsGetPositionPermissionAllowed(true);
    setLatitude(event.coords.latitude);
    setLongitude(event.coords.longitude);
  };

  const errorHandler = () => {
    setIsGetPositionPermissionAllowed(false);
  };

  useEffect(() => {
    // 브라우저에서 처리
    if (!window.ReactNativeWebView) {
      window.navigator.geolocation.getCurrentPosition(successHandler, errorHandler);
    }

    // RN에서 처리
    else if (window.ReactNativeWebView) {
      setRNMessageReceiver({
        messageHandler: (e) => {
          let eventData = { event: '', data: '' };
          try {
            eventData = JSON.parse(e.data);
          } catch (error) {
            // console.log('error :', error);
          }

          if (eventData.event === 'currentPosition') {
            successHandler(eventData.data);
          } else if (eventData.event === 'currentPositionError') {
            errorHandler();
          }
        },
      });

      postMessageToRN({ messageKey: 'getCurrentPosition' });
    }
  }, []);

  return { latitude, longitude, isGetPositionPermissionAllowed };
};
